/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import Main from '../../../components/HOC/Main';
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import Button from '../../../components/common/Button';
import CustomTable from '../../../components/common/CustomTable';
import { clearPartnerData, deletePartner, fetchPartner, selectPartnerData, setPartnerData } from '../../../store/slices/api/inner/partnerSlice';
import { selectSelectedPartner, setSelectedPartner, toggleCommonDeleteModal, togglePartnerSlide } from '../../../store/slices/common';
import PartnerForm from '../../../components/pages/PartnerForm';
import { FaPlus } from 'react-icons/fa';
import TableAction from '../../../components/TableAction';

export const PartnerPage = () => {
  const dispatch = useDispatch();
  const partnerData = useSelector(selectPartnerData);
  const selectedPartner = useSelector(selectSelectedPartner)

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchPartner,
    setValueAction: setPartnerData,
    clearValueActionOnError: clearPartnerData,
    isForm: false,
    successMessage: false,
  });


  // delete start
  const openDeleteModal = (data) => {
    dispatch(setSelectedPartner(data))
    dispatch(toggleCommonDeleteModal())
  }
  const cancelDeleteModal = () => {
    dispatch(setSelectedPartner(null))
    dispatch(toggleCommonDeleteModal())
  }

  const afterAPICall = (res) => {
    fetchData()
    dispatch(toggleCommonDeleteModal())
  }

  const { handleSubmit: handleDelete } = useApiRequest({
    apiAction: deletePartner,
    isForm: false,
    afterAPICall,
  });
  // delete end

  const handleEdit = (data) => {
    dispatch(setSelectedPartner(data));
    dispatch(togglePartnerSlide());
  }

  const handleAdd = () => {
    dispatch(setSelectedPartner(null));
    dispatch(togglePartnerSlide())
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'partner_name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"partner name"
    },
    {
      accessorKey: 'partner_logo',
      cell: info => 
        <div className='h-24 w-28 flex items-center justify-center'>
      <img src={`${process.env.REACT_APP_BASE_URL}/assets/${info.getValue()}`} className='h-full w-auto' alt='partner' />
      </div>,
      header:"partner logo"
    },

    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData();
  }, [])


  return (
    <Main crumbs={[{ title: "masters" }, { title: "partners" }]} handleDelete={() => {handleDelete({ partnerId: selectedPartner.partner_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={partnerData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add partner</Button>} />
      <PartnerForm defaultData={selectedPartner} fetchData={fetchData} />
    </Main>
  );
};
